var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrame10(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 194,
    height: 68,
    viewBox: "0 0 194 68",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1032_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 34.2772L97 0.777161L194 34.2772L97 67.7772L0 34.2772Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5528 18.4238L76.1421 13.0438V17.2761L64.811 20.4324V32.5555L73.4717 32.2686V36.2857L64.811 35.9988V48.1219L76.1421 51.2782V55.5106L60.5528 50.1305V18.4238Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.858 13.0438L133.447 18.4238V21.5802L122.116 18.4238V32.3403L130.705 32.6273V35.9271L122.116 36.214V50.1305L133.447 46.9742V50.1305L117.858 55.5106V13.0438Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.878 11.3221V57.2322L108.331 58.8103V17.0609L97 31.1926L85.6689 17.0609V58.8103L81.122 57.2322V11.3221L85.5967 9.81569L97 23.9474L108.403 9.74396L112.878 11.3221Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9442 45.6112V48.8392L45.3966 44.8939V23.6604L48.7165 22.5127V43.1005L56.9442 45.6112Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.727 36.9313V23.0149L149.181 23.8757V44.6787L147.016 45.4678L140.159 29.3275V47.835L137.272 48.8393L136.984 48.911L137.056 19.6433L139.943 20.6476L146.727 36.9313Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0141 29.184V33.3446L39.9115 33.2011V35.3532L36.0141 35.2814V39.2986L41.9323 41.0919V43.7461L33.0551 40.6615V27.8928L41.9323 24.8082V27.3906L36.0141 29.184Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.182 28.7536L152.068 27.4624V24.8799L162.677 28.5384V30.7622L158.708 29.5427V41.3789L156.182 42.2397V28.7536Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.557 49.7718V51.2782L99.526 61.8232L96.7835 62.8275L99.8869 51.9238H94.6183V53.8607H92.2366V49.7718H102.557Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.093 44.8939H92.2366V43.4592L95.0513 33.5598H97.5052L94.9792 42.5266H99.093V38.1508H101.475V42.5266H102.269V44.8939H101.475V47.9784H99.093V44.8939Z",
    fill: "#1C1C1C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1032_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 194,
    height: 67,
    fill: "white",
    transform: "translate(0 0.777161)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame10);
export default __webpack_public_path__ + "static/media/Frame10.08613bb61fd02cf0eecfa326428f2f1f.svg";
export { ForwardRef as ReactComponent };